import { Crown, X } from "lucide-react";
import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";

export default function UpgradeModal({ open, onClose }) {
  const navigate = useNavigate();
  const closeRef = useRef(null);
  useEffect(() => {
    if (!open) return undefined;
    closeRef.current?.focus();
    const handleKey = (event) => event.key === "Escape" && onClose();
    window.addEventListener("keydown", handleKey);
    return () => window.removeEventListener("keydown", handleKey);
  }, [onClose, open]);
  if (!open) return null;
  return (
    <div
      aria-modal="true"
      className="upgrade-backdrop"
      data-testid="upgrade-modal"
      role="dialog"
    >
      <section className="upgrade-modal">
        <button
          data-testid="upgrade-modal-close"
          onClick={onClose}
          ref={closeRef}
          title="Not now"
        >
          <X size={18} />
        </button>
        <Crown size={25} />
        <p className="eyebrow">Pro tools</p>
        <h2>Continue your post-round review with Pro.</h2>
        <p>
          PFJudgePro Pro includes Round Review, Flow Tracker, Summary & Final
          Focus Review, round history, and ballot exports.
        </p>
        <div>
          <button
            onClick={() => navigate("/pro")}
            data-testid="upgrade-modal-explore-button"
          >
            Explore Pro
          </button>
          <button onClick={onClose} data-testid="upgrade-modal-not-now-button">
            Not now
          </button>
        </div>
      </section>
    </div>
  );
}